import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-upgrade-dialog',
  template: `
    <p-dialog [(visible)]="visible" [modal]="true" [closable]="true" appendTo="body" [dismissableMask]="true" styleClass="dialog1 ss-g-dialog-sized">
      <ng-template pTemplate="header">
        <h4>{{ message }}</h4>
      </ng-template>

      <p>{{ title }}</p>

      <ng-template pTemplate="footer">
        <ng-container *ngIf="showActions; else onlyCloseFooter">
          <button pButton label="Agora não" class="p-button-text" (click)="onClose()"></button>
          <button pButton label="Upgrade" class="p-button" (click)="onUpgrade()"></button>
        </ng-container>
        <ng-template #onlyCloseFooter>
          <button pButton label="Fechar" class="p-button-outlined" (click)="onClose()"></button>
        </ng-template>
      </ng-template>
    </p-dialog>
  `
})
export class UpgradeDialogComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() title = '';
  @Input() message = '';
  // Quando false, o footer mostra só "Fechar" — usado pra reaproveitar o
  // mesmo dialog num cenário de sucesso (sem CTA de upgrade), não só de
  // limite atingido. Default true preserva o comportamento nos outros
  // usos (slick-detail, feed) sem precisar tocar nesses templates.
  @Input() showActions = true;

  @Output() close = new EventEmitter<void>();
  @Output() upgrade = new EventEmitter<void>();
  
  onClose() {
    this.visibleChange.emit(false);  // Apenas emite, quem controla é o pai.
    this.close.emit();
  }

  onUpgrade() {
    this.visibleChange.emit(false);  // Também fecha ao fazer upgrade.
    this.upgrade.emit();
  }
}
